import { RouteRecordRaw } from 'vue-router';

// import { settingsLayoutComponents } from '~/pages/layout/layout';
import { RouteKeys } from '~/router/routes.domain';

export const ResetPasswordRoute: RouteRecordRaw = {
	name: RouteKeys.RESET_PASSWORD,
	path: '/reset-password',
	components: {
		default: () => import('~/_v3/common/ui/pages/ResetPasswordPage.vue')
	},
	meta: {
		requiresAuth: false,
		isSettingsNavEntry: false,
		isSubEntry: false,
		order: 1
	}
};
